export const inlineStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    fontFamily: "inherit",
  },

  // The embed's own panel, drawn only when the console palette sets a
  // background: its text colours are chosen for that background, not the
  // host's card, so a dark palette would otherwise vanish on a light host.
  paintedRoot: {
    padding: "16px",
    boxSizing: "border-box",
  },

  optionItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionLeft: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    cursor: "pointer",
    flexGrow: 1,
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionTextContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  optionTitle: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#101828",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  optionDescription: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#475467",
    verticalAlign: "middle",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  checkboxLarge: {
    height: "20px",
    width: "20px",
    padding: "4px",
    borderRadius: "5px",
    border: "2px solid #d0d5dd",
    margin: 0,
    boxSizing: "border-box",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "transparent",
  },

  dataElementsContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    paddingLeft: "22px",
  },

  dataElementItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "space-between",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    minHeight: "24px",
  },

  productHeading: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    margin: "0 0 8px",
    padding: 0,
    textAlign: "left",
  },

  dataElementText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "0.2px",
    color: "#344054",
    margin: 0,
    padding: 0,
    textAlign: "left",
  },

  checkboxSmall: {
    height: "16px",
    width: "16px",
    padding: "4px",
    borderRadius: "5px",
    border: "2px solid #d0d5dd",
    margin: 0,
    boxSizing: "border-box",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "transparent",
  },

  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    minHeight: "200px",
    margin: 0,
    boxSizing: "border-box",
  },

  loadingSpinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "1rem",
    boxSizing: "border-box",
  },
} as const;
